import { Layout } from "antd";
import { useSelector } from "react-redux";
import "./footer.css";

const { Footer } = Layout;

export default function MenuFooter() {
  const settings = useSelector((state) => state.auth.settings);
  const year = new Date().getFullYear();

  return (
    <Footer className="app-footer">
      <span>
        { (settings && settings.footer_text) || `© ${year} SmileCorrect. All rights reserved.` }
      </span>
    </Footer>
  );
}
